<template>
  <Swiper
    :space-between="10"
    slides-per-view="auto"
    free-mode
    :mousewheel="{forceToAxis: true}"
    :modules="[SwiperFreeMode, SwiperMousewheel]"
  >
    <SwiperSlide
      v-for="message in currentMessageFirst"
      :key="message.title"
      class="group !w-fit"
    >
      <NuxtLink
        :to="message.slug"
        class="btn text w-fit bg-white/80 py-2.5 group-first:cursor-default group-first:bg-white/80 lg:px-5"
      >
        {{ message.title }}
      </NuxtLink>
    </SwiperSlide>
  </Swiper>
</template>

<script lang="ts" setup>
import type {AmbitionsQuery, AmbitionQuery} from '~/graphql/graphql';

const props = defineProps<{
  activeAmbition?: AmbitionQuery['ambition'],
  ambitions: AmbitionsQuery['ambitions'],
  color?: string | null | undefined,
}>();

const currentMessageFirst = computed(() => [...props.ambitions].sort(a => a.slug === props.activeAmbition?.slug ? -1 : 1));
</script>

<style scoped>
.text {
  --color: v-bind(color);

  /* stylelint-disable-next-line function-no-unknown */
  color: var(--color);
}
</style>
